import * as XLSX from 'xlsx';

const DownloadChallanExcel = (allChallans, companyName, setOpenBackdrop) => {
    // Check if data exists
    const challanList = Array.isArray(allChallans) ? allChallans : [allChallans];

    if (challanList.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];

        // --- 1. Header Row (Custom Styling logic is limited in basic XLSX, so we focus on structure) ---
        rows.push([companyName.toUpperCase()]); // Company Header
        rows.push(["BULK DELIVERY CHALLANS REPORT"]);
        rows.push([]); // Empty row for spacing

        // --- 2. Define Table Headers ---
        const tableHeaders = [
            "Challan No", 
            "Date", 
            "Customer Name", 
            "Item Name", 
            "Qty", 
            "Rate", 
            "Item Amount", 
            "Total Bill Amount",
            "Bill To Address"
        ];
        rows.push(tableHeaders);

        // --- 3. Fill Data ---
        challanList.forEach((challan) => {
            // Har challan ke items ko iterate karein
            challan.items.forEach((item, index) => {
                rows.push([
                    index === 0 ? challan.challan_no : "",      // Sirf pehli line mein challan no dikhayein
                    index === 0 ? challan.challan_date : "",    // Sirf pehli line mein date
                    index === 0 ? (challan.customer?.contact_name || 'N/A') : "", 
                    item.itemname,
                    item.qty,
                    item.rate,
                    item.amount,
                    index === 0 ? challan.total_amount : "",    // Total amount 
                    index === 0 ? challan.bill_to_address : ""  // Address
                ]);
            });
            // Ek challan ke baad khali row taaki doosra alag dikhe
            rows.push([]); 
        });

        // --- 4. Create Workbook & Sheet ---
        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Challans");

        // --- 5. Column Width Formatting ---
        const wscols = [
            { wch: 15 }, // Challan No
            { wch: 20 }, // Date
            { wch: 20 }, // Customer
            { wch: 30 }, // Item Name
            { wch: 10 }, // Qty
            { wch: 10 }, // Rate
            { wch: 12 }, // Amount
            { wch: 15 }, // Total
            { wch: 50 }, // Address
        ];
        worksheet['!cols'] = wscols;

        // --- 6. Download ---
        const timestamp = new Date().getTime();
        XLSX.writeFile(workbook, `Challans_Report_${timestamp}.xlsx`);

    } catch (error) {
        console.error("Excel Generation Error:", error);
        alert("Excel generate karne mein problem hui!");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadChallanExcel;